import React, { useEffect, useState } from 'react';
import {
  setPersistence,
  browserLocalPersistence,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../../firebase';
import LoginForm from './renderers/LoginForm';
import Toast from './renderers/Toast';
import { loginConfig } from './services/config';
import { useTheme } from '../../hooks/useTheme';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const themeFromQuery = queryParams.get('theme');
  const logout = queryParams.get('logout');

  const { setTheme } = useTheme(); // ⬅️ novo uso do hook

  const [toastMessage, setToastMessage] = useState('');
  const [toastStatus, setToastStatus] = useState(false);
  const [toastShow, setToastShow] = useState(false);
  const [disabledForm, setDisabledForm] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [formData, setFormData] = useState({});
  const [formSchema, setFormSchema] = useState();
  const [formUISchema, setFormUISchema] = useState();

  useEffect(() => {
    setFormSchema({
      title: 'Autenticação de formulário',
      description: 'Para acessar o formulário, informe o seu login e senha abaixo.',
      type: 'object',
      required: ['email', 'password'],
      properties: {
        email: { type: 'string', title: 'E-MAIL' },
        password: { type: 'string', title: 'SENHA' },
      },
    });

    setFormUISchema({
      email: {
        'ui:widget': 'email',
        'ui:placeholder': 'O seu e-mail de acesso',
      },
      password: {
        'ui:widget': 'password',
        'ui:placeholder': 'Qual a sua senha?',
      },
    });
  }, []);

  // Aplica e salva o tema se vier via URL
  useEffect(() => {
    if (themeFromQuery) {
      localStorage.setItem('theme', themeFromQuery);
      setTheme(themeFromQuery); // ⬅️ aplica via hook
    }
  }, [themeFromQuery, setTheme]);

  useEffect(() => {
    if (logout === 'true') {
      const localQueryParams = new URLSearchParams(location.search);

      setToastMessage('Logout realizado com sucesso.');
      setToastStatus(true);
      setToastShow(true);

      setTimeout(() => {
        setToastShow(false);
        localQueryParams.delete('logout');
        const newUrl = `${location.pathname}?${localQueryParams.toString()}`;
        window.history.replaceState(null, '', newUrl);
      }, loginConfig.toastTimeout);
    }
  }, [logout, location.pathname, location.search]);

  useEffect(() => {
    setDisabledButton(!(formData?.email && formData?.password));
  }, [formData]);

  const onLogin = async () => {
    setDisabledForm(true);
    try {
      await setPersistence(auth, browserLocalPersistence);
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      const user = userCredential.user;

      const name = user.displayName || '';
      setToastMessage(
        name
          ? `Olá ${name}. Aguarde um pouco enquanto preparamos tudo para você...`
          : 'Login efetuado! Aguarde um instante por favor...'
      );
      setToastStatus(true);
      setToastShow(true);

      setTimeout(() => setToastShow(false), loginConfig.toastTimeout);

      const redirectParam = queryParams.get('redirect');
      navigate(redirectParam || loginConfig.redirectPath(Object.fromEntries(queryParams.entries())));
    } catch (error) {
      console.error('Erro ao autenticar', error);
      setToastMessage('Erro no Login. Tente novamente.');
      setToastStatus(false);
      setToastShow(true);
      setTimeout(() => setToastShow(false), loginConfig.toastTimeout);
    } finally {
      setDisabledForm(false);
    }
  };

  return (
    <>
      <div className="card card-login vertical-center bg-gray-300">
        {formSchema && formUISchema && (
          <LoginForm
            schema={formSchema}
            uiSchema={formUISchema}
            disabled={disabledForm}
            disabledButton={disabledButton}
            onSubmit={onLogin}
            onChange={({ formData }) => setFormData(formData)}
            formData={formData}
          />
        )}
      </div>
      {toastShow && <Toast status={toastStatus} message={toastMessage} />}
    </>
  );
};

export default LoginPage;
